import { useEffect, useRef } from "react";

/** Přenačte data, když se uživatel do aplikace vrátí (přepnutí záložky nebo
 *  aplikace, odemčení telefonu). Kolegové mezitím mohli něco změnit a člověk
 *  by jinak koukal na stará data, dokud sám neobnoví stránku. Nejvýš jednou
 *  za 5 s, ať se to při rychlém přepínání nenačítá pořád dokola. */
export function useObnovaPriNavratu(nacti) {
  const fn = useRef(nacti);
  fn.current = nacti;
  useEffect(() => {
    let posledni = Date.now();
    const obnov = () => {
      if (document.visibilityState !== "visible" || Date.now() - posledni < 5000) return;
      posledni = Date.now();
      fn.current?.();
    };
    window.addEventListener("focus", obnov);
    document.addEventListener("visibilitychange", obnov);
    return () => {
      window.removeEventListener("focus", obnov);
      document.removeEventListener("visibilitychange", obnov);
    };
  }, []);
}
